var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFaviconDark(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.53397 6.60303C11.6517 2.48528 18.3279 2.48528 22.4457 6.60303L24.9309 4.11775C19.4406 -1.37258 10.539 -1.37258 5.04869 4.11775L7.53397 6.60303Z",
    fill: "#3807D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9604 9.08831C17.2152 6.34314 12.7644 6.34314 10.0192 9.08831L12.5045 11.5736C13.8771 10.201 16.1025 10.201 17.4751 11.5736C18.8477 12.9462 18.8477 15.1716 17.4751 16.5442L19.9604 19.0294C22.7055 16.2843 22.7055 11.8335 19.9604 9.08831Z",
    fill: "#3807D9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9898 19.0294L17.4751 16.5442L19.9604 19.0294L17.4751 21.5147L14.9898 19.0294Z",
    fill: "#3807D9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.078125 9.08831L2.56341 6.60303L17.4751 21.5147L14.9898 24L0.078125 9.08831Z",
    fill: "#3807D9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9494 9.10605L27.4347 6.62077L29.92 9.10605L27.4347 11.5913L24.9494 9.10605Z",
    fill: "#3807D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaviconDark);
export default __webpack_public_path__ + "static/media/favicon-dark.2d276752259e16cd421c516e8bc92ea8.svg";
export { ForwardRef as ReactComponent };